import {AccountingSubjectContextEntry} from '@dms/api/core';

export const findAccountingSubjectContextId = (
  context: AccountingSubjectContextEntry[],
  type: AccountingSubjectContextEntry['type']
) => context.find((entry) => entry.type === type)?.id;
